<template>
    <!--main-->
    <main class="main" role="main">
      <header class="header">
        <div class="header__inner type_02">
          <div class="header__btns">
            <button class="header__btns prev" @click="close"></button>
          </div>
          <h1 class="header__ttl">알림 내역</h1>
          <div class="header__btns"></div>
        </div>
      </header>
      <div class="main__inner"><!-- 배경: bg-->
        <div class="main__con">
          <div class="notice__page">
            <ul class="notice__page__ul">
              <li class="notice__page__li" v-for="(push, index) in pushList" :key="index">
                <div class="txt">
                  <p v-html="push.pushDescription"></p>
                  <p class="date">{{ $Util.dateFormat(push.regDate, 'YYYY. MM. DD') }}<span class="time"><i class="i_time_gr50"></i> {{ $Util.timeFormat(push.regDate) }}</span></p>
                </div>
              </li>
            </ul>
            <button class="btn" @click="doLogin">이동</button>
          </div>
        </div>
      </div>
    </main>
</template>
<script>
import AccountSvc from "@/common/service/AccountSvc";

export default {
  name: 'manager-notice-modal',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  },
  data: function () {
    return {
      pushList: []
    }
  },
  created: function () {
    this.getPushLogListData()
  },
  methods: {
    doLogin: async function () {
      const res = await AccountSvc.refreshElectUserData({userNo: this.data.userNo, managerUserNo: this.data.managerUserNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        setTimeout(() => {
          this.$CommonSvc.updateReadManagerPushLog({userNo: this.data.userNo, managerUserNo: this.data.managerUserNo})
        }, 1)
        await this.$router.push('/main/home')
      }
    },
    getPushLogListData: async function () {
      const res = await this.$CommonSvc.getManagerPushLog({userNo: this.data.userNo, managerUserNo: this.data.managerUserNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log(entity)

      if (code === 1) {
        this.pushList = entity
      }
    },
    close: function () {
      this.$emit('eventClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  position: absolute;
  bottom: 1rem;
  color: white;
  font-size: 1.4rem;
  font-weight: 500;
  background: #424242;
  border-radius: 0.4rem;
  width: calc(100% - 2rem);
  margin-left: 1rem;
  text-align: center;
  height: 3.6rem;
  line-height: 3.6rem;
}
</style>
